import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { Cross, LockKey } from "@phosphor-icons/react";

export default function AdminLogin() {
    const { user, login } = useAuth();
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [submitting, setSubmitting] = useState(false);

    if (user) return <Navigate to="/admin" replace />;

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");
        setSubmitting(true);
        try {
            await login(email, password);
            navigate("/admin");
        } catch (err) {
            setError(formatApiErrorDetail(err.response?.data?.detail) || "Login failed.");
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div data-testid="admin-login-page" className="min-h-screen bg-[#4C1D95] flex items-center justify-center px-6 py-12">
            <div className="w-full max-w-md">
                <div className="flex items-center gap-3 mb-8 justify-center">
                    <span className="w-12 h-12 bg-[#FFC72C] flex items-center justify-center">
                        <Cross size={22} weight="bold" className="text-slate-900" />
                    </span>
                    <div className="text-white">
                        <p className="font-serif text-lg font-bold leading-tight">Greater Mount Olive</p>
                        <p className="text-[10px] uppercase tracking-[0.2em] text-[#FFC72C] font-semibold">Admin Portal</p>
                    </div>
                </div>
                <div className="bg-white p-10">
                    <div className="flex items-center gap-3 mb-6">
                        <LockKey size={24} weight="bold" className="text-slate-900" />
                        <h1 className="font-serif text-2xl font-bold text-slate-900">Admin Login</h1>
                    </div>
                    <form onSubmit={handleSubmit} className="space-y-5" data-testid="admin-login-form">
                        <div>
                            <label className="block text-xs uppercase tracking-[0.15em] font-semibold text-slate-700 mb-2">Email</label>
                            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-email-input" className="w-full border border-slate-300 px-4 py-3 focus:outline-none focus:border-slate-900" />
                        </div>
                        <div>
                            <label className="block text-xs uppercase tracking-[0.15em] font-semibold text-slate-700 mb-2">Password</label>
                            <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password-input" className="w-full border border-slate-300 px-4 py-3 focus:outline-none focus:border-slate-900" />
                        </div>
                        {error && <p className="text-sm text-red-600" data-testid="login-error">{error}</p>}
                        <button type="submit" disabled={submitting} data-testid="admin-login-submit" className="w-full bg-[#4C1D95] hover:bg-[#3B0F75] text-white px-6 py-3 text-sm font-semibold uppercase tracking-wide transition-colors disabled:opacity-50">
                            {submitting ? "Signing in..." : "Sign In"}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
}
